<template>
    <div class="campo-form">
        <div class="label-container">
            <label>{{ label }}<span style="color: #bb2a17" v-if="required">*</span></label>
            <slot name="acoes"></slot>
        </div>
        <InputNumber
            class="input"
            locale="pt-BR"
            :placeholder="placeholder"
            :name="name"
            v-model="inputValue"
            :useGrouping="false"
            @keydown="onKeydown"
            @update:modelValue="emit('update:modelValue', $event)"
        />
    </div>
</template>

<script setup>
import { ref, defineEmits, defineProps } from 'vue';

const props = defineProps({
    label: String,
    placeholder: String,
    name: String,
    helpText: String,
    modelValue: String,
    required: Boolean,
    length: Number,
});

const emit = defineEmits(['update:modelValue']);
const inputValue = ref(props.modelValue || null);

const onKeydown = (event) => {
    if (!props.length) {
        return;
    }

    const valorAtual = event.target.value || '';
    if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(event.key)) {
        return;
    }

    if (valorAtual.length >= props.length) {
        event.preventDefault();
    }
};
</script>

<style scoped lang="scss">
.campo-form {
    width: 100%;

    .input {
        width: 100%;
    }

    .label-container {
        padding-bottom: 4px;
        display: flex;
        align-items: center;
        gap: 10px;
        font-weight: 700;
        color: #252529;
    }
}
</style>
